import { QueryClient } from '@tanstack/react-query';

import { isApiError } from '@/lib/api';

/**
 * Configuration globale de TanStack Query.
 *
 * L'enjeu principal ici est de **ne pas réessayer les erreurs définitives** :
 * rejouer trois fois un 403 ou un 404 retarde l'affichage du message et
 * multiplie la charge serveur pour rien.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // Les données d'un ATS changent à l'échelle de la minute, pas de la seconde.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          if (isApiError(error) && !error.isRetryable) return false;
          return failureCount < 2;
        },
        // Un recruteur bascule sans cesse entre onglets : un rafraîchissement
        // à chaque retour de focus serait bruyant et coûteux.
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        // Une mutation rejouée automatiquement peut dupliquer une candidature :
        // les retries sont déclenchés explicitement par l'appelant.
        retry: false,
      },
    },
  });
